import React from "react";

import Helmet from "react-helmet";

import Header from "@components/header";
import Footer from "@components/footer";

import { Collapse, Row, Col } from "antd";

import pcImg from "@src/images/question/Rectangle4387.png";
import phoneImg from "@src/images/question/Rectangle4386.png";

import TextCenterBanner from "@components/textCenterBanner";
import { useI18n } from "@src/i18n";

import * as styles from "./index.module.scss";

const QuestionPage = () => {
  const { t } = useI18n();
  const questionDatas = t("questionPage.items");

  return (
    <div className={styles.questionPage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("questionPage.title")}</title>
      </Helmet>
      <Header />
      <TextCenterBanner
        pcImg={pcImg}
        phoneImg={phoneImg}
        text={t("questionPage.banner")}
      />
      <Row>
        <Col xs={0} sm={0} md={24}>
          <div className={styles.content}>
            {questionDatas.map((item) => {
              return (
                <div className={styles.questionContainer} key={item.question}>
                  <div className={styles.question}>{item.question}</div>
                  <div className={styles.answer}>{item.answer}</div>
                </div>
              );
            })}
          </div>
        </Col>
        <Col xs={24} sm={24} md={0}>
          <div className={styles.smallContent}>
            <Collapse
              defaultActiveKey={[0]}
              expandIconPosition="right"
              ghost
              bordered="false"
            >
              {questionDatas.map((item) => (
                <Collapse.Panel header={item.question} key={item.question}>
                  {item.answer}
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
        </Col>
      </Row>

      <Footer />
    </div>
  );
};

export default QuestionPage;
